import { QueryClientProvider } from "@tanstack/react-query";
import { useLanguage } from "hooks";
import { useQueryClientProvider } from "libs/reactQuery";
import { SocketsProvider } from "libs/soket";
import { SupportUnreadProvider } from "modules/common";
import moment from "moment";
import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import Modal from "react-modal";
import "libs/localization";
import { BrowserRouter } from "react-router-dom";
import { Routes } from "routes";

Modal.setAppElement("#root");

function App() {
  const queryClient = useQueryClientProvider();
  const { currentLanguage } = useLanguage();

  useEffect(() => {
    moment.locale(currentLanguage);
  }, [currentLanguage]);

  return (
    <SocketsProvider>
      <QueryClientProvider client={queryClient}>
        <SupportUnreadProvider>
          <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          >
            <Routes />
          </BrowserRouter>
        </SupportUnreadProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            success: { duration: 3000 },
            error: { duration: 3000 }
          }}
          reverseOrder={false}
        />
      </QueryClientProvider>
    </SocketsProvider>
  );
}

export default App;
